module.exports = {"370104001":"振兴街街道","370104002":"中大槐树街道","370104003":"道德街街道","370104004":"西市场街道","370104005":"五里沟街道","370104006":"营市街街道","370104007":"青年公园街道","370104008":"南辛庄街道","370104009":"段店北路街道","370104010":"张庄路街道","370104011":"匡山街道","370104012":"美里湖街道","370104013":"腊山街道","370104014":"兴福街道","370104015":"玉清湖街道","370104016":"吴家堡街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370104.json
// module id = 1353
// module chunks = 0